import { RouteItem } from '@eastcoal/router/types/route'

import { UNFREEZE_APPLY_LIST_ROUTE_PAGE_PATH } from './constants/path'
import { UNFREEZE_APPLY_LIST_PAGE_UUID } from './constants/uuid'

export const unfreezeApplyRoute: RouteItem = {
  title: '保证金解冻',
  path: UNFREEZE_APPLY_LIST_ROUTE_PAGE_PATH,
  uuid: UNFREEZE_APPLY_LIST_PAGE_UUID,
  Component: () => import('./index')
}
